import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 24px;\n  flex: 1;\n'], ['\n  margin-top: 24px;\n  flex: 1;\n']);

import styled from 'styled-components';
// import { gridSize, fontSize, colors, themed } from '@atlaskit/theme';

/**
 * Provide a styled container for form headers.
 */
export var FormFooterWrapper = styled.footer(_templateObject);